export{Tooltip,TrailingTooltip}from"@vds-core/tooltips";
